export default __webpack_public_path__ + "static/media/jpeg.9a6bd112.svg";